<template>
  <div class="bottom-region">
    <div class="bottom-region_icp">
      <a href="https://beian.miit.gov.cn" target="_blank" class="bottom-region_a">
        <p style="height:20px; line-height:20px; margin: 0px 0px 0px 5px; color:#939393;">浙ICP备2025200348号-1</p>
      </a>
    </div>
    <!-- <div class="bottom-region_security">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502020059" class="bottom-region_a">
        <img src="https://user-images.githubusercontent.com/128205718/260667739-e0e29cbb-790b-4320-a3ae-ab785d9cdd08.png" style="float:left;"/>
        <p style="float:left; height:20px; line-height:20px; margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011502020059号</p>
      </a>
    </div> -->
    <div class="bottom-region_company">Copyright 2025 爱跟爱科技（宁波）有限公司. All Rights Reserved</div>
    <!--公安备案源代码-->
    <!-- <div style="width:300px;margin:0 auto; padding:20px 0;"> <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502020059" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011502020059号</p></a> </div> -->
  </div>
</template>
<script>
  export default {
    name: 'AI-Bottom-ICP'
  }
</script>
<style lang="less" scoped>
  .bottom-region{
    position: absolute;
    width: 100%;
    bottom: 0px;
    min-height: 100px;
    border-top: 1px solid #cbc3c3;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    &_icp{
      height: 20px;
      padding-top: 20px;
    }
    &_security{
      height: 20px;
      margin-left: 20px;
      padding-top: 20px;
    }
    &_company {
      flex: none;
      height:20px; 
      line-height:20px; 
      color:#939393;
      flex-basis: 100%;
      text-align: center;
    }
  }
  .bottom-region_a{
    text-decoration:none;
    height:20px;
    line-height:20px;
  }
</style>